export default "__VITE_ASSET__DmHaTg5z__"